module.exports = __webpack_public_path__ + "static/product-l0980-daa7ea8d6fc44875b02773d8df2cdf00.png";